import { buildBindable } from '@monofe/di';
import { injectENV, injectLog, TYPES as UTIL_TYPES } from '@monofe/util';
import type { IStoreMiddlewares } from '../interface';
import {
    bindStoresMiddleware,
    injectStoresMiddleware,
    TYPES,
    unbindStoresMiddleware,
} from '../interface';
import buildMiddlewares from './builder';

export default buildBindable<IStoreMiddlewares>({
    id: TYPES.IStoreMiddlewares,
    dependencies: [UTIL_TYPES.ILog, UTIL_TYPES.IEnv],
    bind: bindStoresMiddleware,
    remove: unbindStoresMiddleware,
    build: container => {
        const logger = injectLog(container);
        const env = injectENV(container);
        return Promise.resolve(buildMiddlewares(logger, env));
    },
    inject: injectStoresMiddleware,
});
